"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _resource = _interopRequireDefault(require("./resource"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var imageExists = function imageExists(img) {
  return img && img.complete && img.naturalHeight !== 0;
};
var getInitialResource = function getInitialResource(src, img) {
  if (src) {
    // If the browser's already loaded this image, we don't show the placeholder
    return imageExists(img) ? new _resource["default"](_resource["default"].COMPLETE) : new _resource["default"](_resource["default"].LOADING);
  }
  return new _resource["default"](null);
};

/**
 * ImageState allows you to create a custom handler for images, reacting to any of four states: `loading`, `failed`, `empty`, or `complete`.
 * The child passed to ImageState should be a function and will receive the current state as an argument, as well as `status`, and the image source.
 */
var ImageState = /*#__PURE__*/function (_Component) {
  function ImageState(props) {
    var _this;
    _classCallCheck(this, ImageState);
    _this = _callSuper(this, ImageState, [props]);
    var src = props.src;
    if (src) {
      _this.createImageLoadingCycle(src);
    }
    _this.state = {
      resource: getInitialResource(src, _this.img),
      width: src && _this.img ? _this.img.naturalWidth : 0
    };
    return _this;
  }
  _inherits(ImageState, _Component);
  return _createClass(ImageState, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.src !== prevProps.src) {
        this.restartImageLoadingCycle(this.props.src);
        this.setState({
          resource: getInitialResource(this.props.src, this.img)
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyImageLoadingCycle();
    }
  }, {
    key: "getResourceForSrc",
    value: function getResourceForSrc(src) {
      return src ? new _resource["default"](_resource["default"].LOADING) : new _resource["default"](null);
    }
  }, {
    key: "createImageLoadingCycle",
    value: function createImageLoadingCycle(src) {
      // There's no Image available on the server and IS_BROWSER/exEnv.canUseDOM both return true
      //   during 'npm run test-app'. Added DOOW-228 to track need for pure browser/server test runs.
      if (typeof Image !== 'undefined' && src) {
        this.img = new Image();
        this.img.onload = this.handleComplete.bind(this);
        this.img.onerror = this.handleError.bind(this);
        this.img.src = src;
      }
    }
  }, {
    key: "destroyImageLoadingCycle",
    value: function destroyImageLoadingCycle() {
      if (this.img) {
        this.img.onload = null;
        this.img.onerror = null;
        this.img = null;
      }
    }
  }, {
    key: "restartImageLoadingCycle",
    value: function restartImageLoadingCycle(src) {
      this.destroyImageLoadingCycle();
      this.createImageLoadingCycle(src);
    }
  }, {
    key: "handleComplete",
    value: function handleComplete(event) {
      this.destroyImageLoadingCycle();
      this.setState({
        resource: new _resource["default"](_resource["default"].COMPLETE),
        width: event.target && event.target.naturalWidth
      });
      if (this.props.onComplete) {
        this.props.onComplete(event);
      }
    }
  }, {
    key: "handleError",
    value: function handleError(event) {
      this.destroyImageLoadingCycle();
      this.setState({
        resource: new _resource["default"](_resource["default"].FAILED)
      });
      if (this.props.onError) {
        this.props.onError(event);
      }
    }
  }, {
    key: "getStatus",
    value: function getStatus() {
      if (this.state.resource.isEmpty()) {
        return 'empty';
      }
      if (this.state.resource.isLoading()) {
        return 'loading';
      }
      if (this.state.resource.isError()) {
        return 'failed';
      }
      if (this.state.resource.isComplete()) {
        return 'completed';
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        src = _this$props.src;
      var statusName = this.getStatus();
      return children(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, statusName, true), "status", statusName), "source", src), "width", this.state.width));
    }
  }]);
}(_react.Component);
ImageState.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Required child function that passes in the current status of the loading image.
   */
  children: _propTypes["default"].func.isRequired,
  /**
   * Function to execute in case the image errors out
   */
  onError: _propTypes["default"].func,
  /**
   * Function to execute once image has completed loading
   */
  onComplete: _propTypes["default"].func,
  /**
   * Source for image to load
   */
  src: _propTypes["default"].string
} : {};
var _default = exports["default"] = ImageState;